import { api, setConfig, UPDATE_SUCCESS_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const updateUser = (data: PropertyType): Promise<string | void> =>
	api.post('/user/update', mapEntityToApi(data), setConfig(data)).then(() => {
		return UPDATE_SUCCESS_MESSAGE;
	});
